import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: '',
    templateUrl: './qualified-user.component.svg',
    styleUrls: ['./qualified-user.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QualifiedUserComponent {}
